
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Calendar, Users, BarChart, MessageSquare, Smartphone } from "lucide-react";
import { SchedulingTool } from "./SchedulingTool";
import { UserTable } from "./UserTable";
import { StatisticsDashboard } from "./StatisticsDashboard";
import { SmsManager } from "./SmsManager";
import { DeviceManager } from "./DeviceManager";
import { UserWithRole } from "@/types/admin";

interface AdminTabsProps {
  users: UserWithRole[];
  onRoleUpdate: () => void;
}

export const AdminTabs = ({ users, onRoleUpdate }: AdminTabsProps) => {
  return (
    <Tabs defaultValue="scheduling" className="space-y-4">
      <TabsList className="grid w-full grid-cols-5">
        <TabsTrigger value="scheduling" className="flex items-center gap-2">
          <Calendar className="h-4 w-4" />
          Planlægning
        </TabsTrigger>
        <TabsTrigger value="users" className="flex items-center gap-2">
          <Users className="h-4 w-4" />
          Brugere
        </TabsTrigger>
        <TabsTrigger value="statistics" className="flex items-center gap-2">
          <BarChart className="h-4 w-4" />
          Statistik
        </TabsTrigger>
        <TabsTrigger value="sms" className="flex items-center gap-2">
          <MessageSquare className="h-4 w-4" />
          SMS
        </TabsTrigger>
        <TabsTrigger value="devices" className="flex items-center gap-2">
          <Smartphone className="h-4 w-4" />
          Enheder
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="scheduling">
        <SchedulingTool users={users} />
      </TabsContent>
      
      <TabsContent value="users">
        <UserTable users={users} onRoleUpdate={onRoleUpdate} />
      </TabsContent>

      <TabsContent value="statistics">
        <StatisticsDashboard />
      </TabsContent>

      <TabsContent value="sms">
        <SmsManager />
      </TabsContent>

      <TabsContent value="devices">
        <DeviceManager />
      </TabsContent>
    </Tabs>
  );
};
